import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminFileStatusesListHeader from './ListHeader';
import AdminFileStatusesListItem from './ListItem';

const AdminFileStatusesList = ({
  statuses,
  timestamp,
  updateStatusOnList,
  deleteStatusFromList,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list statuses-list" responsive>
      <thead>
        <AdminFileStatusesListHeader
          {...props}
        />
      </thead>
      <tbody>
        {statuses.map(status => (
          <AdminFileStatusesListItem
            key={status.id}
            status={status}
            timestamp={timestamp}
            updateStatusOnList={updateStatusOnList}
            deleteStatusFromList={deleteStatusFromList}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminFileStatusesList.propTypes = {
  statuses: PropTypes.array.isRequired,
  timestamp: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  updateStatusOnList: PropTypes.func.isRequired,
  deleteStatusFromList: PropTypes.func.isRequired,
};

export default AdminFileStatusesList;
